function isWithinRange(date, min, max) {
  return (!min || date >= min) && (!max || date <= max);
}

export { isWithinRange };
//# sourceMappingURL=isWithinRange.mjs.map
